<div class="card h-100 wow flipInX" data-wow-delay="delay">
  <div class="card-img-top">
    <img class="img-fluid" [src]="safeSrc" alt="{{title}}" title="{{title}}">
  </div>
  <div class="card-body">
      <h3>{{title}}</h3>
      <p class="display-7 pre-wrap" [innerHTML]="bodytext"></p>
  </div>
</div>
